import {Common, ictAxios as axios} from "@plm/o10-share-front";
import {instance} from "@posco/posco-shared";

class O10g014111Repository {

  @instance
  static instance;

  readOnly = "/o10rq0-readonly/o10g014111";
  apiUrl = "/o10g01-invcommon/o10g014111";

  axiosConfig = {
    headers: {
      "Content-Type": "application/json"
    }
  };

  /**
   * 개인정보
   */
  userInfoFind() {
    return axios.post(`${this.apiUrl}/${Common.PotalUtil.getStorageItem("gcsCompCode")}/${Common.PotalUtil.getStorageItem("Posco.auth.userInfo").smrtNoteUserId}`)
      .then(response => response && response.data);
  }

  /**
   * 사업 정보 조회
   */
  invbpInfoFind() {
    const data = {
      gcsCompCode: Common.PotalUtil.getStorageItem("gcsCompCode"),
      smrtNoteUserId: Common.PotalUtil.getStorageItem("Posco.auth.userInfo").smrtNoteUserId
    };
    return axios.post(`${this.readOnly}/find`, data)
      .then(response => response && response.data);
  }

  /**
   * 사업 정보 조회 - 상세 (제안, 설계, CM, 누계)
   */
  invbpInfoFindDetail(target) {
    const data = {
      target: target
    };
    return axios.post(`${this.readOnly}/findDetail`, data)
      .then(response => response && response.data);
  }
}

export default O10g014111Repository;
